import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit';
import { resetOrder } from '../../actions/currentOrder';

const initialState = false;

const slice = createSlice({
  name: '$bypassDeliveryDetails',
  initialState,
  reducers: {
    setBypassDeliveryDetails(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(resetOrder, (state, action) => {
      return initialState;
    });
  },
});

export const { setBypassDeliveryDetails } = slice.actions;
export default slice.reducer;
